import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {TripbookPackage} from "../../entities/Agency.ts";

export class AddAgencyPackageUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    async execute(agencyId: string, unitPrice: number, quantity: number, date: number, numberOfPagesIncluded?: number): Promise<TripbookPackage> {
        return this.agencyRepository.addAgencyPackage(agencyId, unitPrice, quantity, date, numberOfPagesIncluded)
    }
}
